<template>
  <div class="p-6">
    <div class="flex items-center gap-3 NewPart mb-10">
      <icon
        :data="icons.returnPartenaire"
        height="48"
        width="53"
        original
        @click="$emit('back')"
        class="cursor-pointer"
      />
      Détails du profil
    </div>

    <div class="flex items-center justify-between gap-5">
      <!-- Informations SFD -->
      <div class="bg-white w-2/3 rounded-14 p-5 h-56">
        <div class="flex items-center gap-3">
          <div>
            <icon
              :data="icons.IconFececamBenin"
              height="64"
              width="64"
              class="w-5 h-5"
              original
            />
          </div>
          <div>
            <div class="font-c7 text-c26">
              {{ partner?.sfd?.name || 'Nom SFD inconnu' }}
            </div>
            <div class="flex justify-start items-center gap-2 text-6b font-c4 text-c16">
              <icon
                :data="icons.IconMail"
                height="14"
                width="11"
                class="w-5 h-5"
                original
              />
              {{ partner?.sfd?.email || 'Email non disponible' }}
            </div>
          </div>
        </div>

        <div class="flex justify-between items-center gap-5 mt-4">
          <div class="bgGray w-full rounded-12 bL pl-5 py-3">
            <div class="font-c7 text-c26 flex">
              {{ partner?.totalCommerce || 0 }}
            </div>
            <div class="font-c4 text-c13 flex">
              Entreprises affiliées
            </div>
          </div>
          <div class="bgGray w-full rounded-14 bR pl-5 py-3">
            <div class="font-c7 text-c26 flex">
              {{ partner?.sfd?.nbPrograms || 0 }}
            </div>
            <div class="font-c4 text-c13 flex">
              Programmes
            </div>
          </div>
        </div>
      </div>

      <!-- Informations Administrateur -->
      <div class="bg-white w-1/3 rounded-14 p-8 h-56">
        <div class="flex justify-between items-center">
          <div>Administrateur</div>
          <div>
            <icon
              data="icons.IconEdit"
              height="20"
              width="20"
              class="w-5 h-5 cursor-pointer"
              original
            />
          </div>
        </div>
        <div class="mt-22">
          <div class="flex font-c5 text-c20">
            {{ partner?.admin?.firstName || '' }} {{ partner?.admin?.lastName || '' }}
          </div>
          <div class="flex font-c4 text-c16 text-6b">
            {{ partner?.admin?.email || 'Email non disponible' }}
          </div>
        </div>
      </div>
    </div>

    <listeDetailsVue />
  </div>
</template>

<script>
import returnPartenaire from '../../../assets/icons/ic-returnPartenaire.svg';
import IconFececamBenin from '../../../assets/icons/ic-fececamBenin.svg';
import IconMail from '../../../assets/icons/ic_mail.svg';
import IconEdit from '../../../assets/icons/ic_edit.svg';
import listeDetailsVue from './listeDetails.vue';

export default {
  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
  components: {
    listeDetailsVue,
  },
  data() {
    return {
      icons: {
        returnPartenaire,
        IconFececamBenin,
        IconMail,
        IconEdit,
      },
    };
  },
  emits: ['back'],
};
</script>

<style>
.bgGray {
  background-color: #F6F9FC;
}
.bL {
  border-left: #591DE8 5px solid;
}
.bR {
  border-left: #F04C36 5px solid;
}
</style>
